'use client'
import IconsMarquee from 'v1/common-components/icons-marquee/IconsMarquee'

export default function MarqueeWrapper({
  heroMarqueeImages,
  classes,
}: {
  heroMarqueeImages: any
  classes: any
}) {
  return (
    <div>
      <IconsMarquee
        animate={{x: ['0%', '-50%']}}
        list={[...heroMarqueeImages, ...heroMarqueeImages]}
        iconBoxClass={classes.marqueeLogoBox}
        customMarqueeContainer={classes.heroMarqueeContainer}
      />
    </div>
  )
}
